import {Component,OnInit} from "@angular/core";
import {ListView} from "@domain/common/list-view";
import {ExportClef} from "@domain/admin/parametre/api/clefs/ExportClef";
import {ApiClefItem} from "./item/api-clef-item.component";
import {ApiClefsService} from "@services/admin/parametre/api/api-clefs.service";
import {TranslateService} from "@ngx-translate/core";
import {MatLegacyDialog as MatDialog} from "@angular/material/legacy-dialog";
import {ApiClefAddComponent} from "@components/admin/parametre/api/clefs/add/api-clef-add.component";
import {BehaviorSubject} from "rxjs";
import {FloatingButtonAction,TypeAction} from "@share/component/floating-button/floating-button";

/**
 * Onglet API Clefs
 *
 * @author Guillaume TRAVOT
 * @date 21/11/2023
 */
@Component({
    host: {'data-test-id': 'api-clefs'},
    templateUrl: './api-clefs.component.html'
})
export class ApiClefsComponent implements OnInit {
    /** Liste des clefs API */
    listeClefApi: ListView<ExportClef,ApiClefItem>;

    /** Liste des actions possibles */
    listeActions: BehaviorSubject<Array<FloatingButtonAction>> = new BehaviorSubject<Array<FloatingButtonAction>>(null);

    /**
     * Constructeur
     */
    constructor(
        private apiClefsService: ApiClefsService,
        private translateService: TranslateService,
        private matDialog: MatDialog) {
    }

    /**
     * Initialisation du composant
     */
    ngOnInit(): void {
        //Définition de la liste des clefs
        this.listeClefApi = new ListView<ExportClef,ApiClefItem>({
            uri: `/controller/InterfaceReferentiel/ClefExport/getListeClefs`,
            title: this.translateService.instant('admin.parametres.api.clef.title'),
            component: ApiClefItem,
            isSearchBar: false,
            isFilter: false,
            isFilterVisible: false,
            defaultOrder: 'clef',
            extraOptions: {
                refresh: () => this.listeClefApi.refresh && this.listeClefApi.refresh()
            }
        });

        //Initialisation des actions possibles
        this.listeActions.next([{
            type: TypeAction.PRIMARY,
            icone: 'nio icon-ajouter',
            libelle: 'global.actions.creer',
            doAction: () => this.addClef()
        }]);
    }

    /**
     * Ouverture de la popin de création d'une clef
     */
    addClef(): void {
        //Ouverture de la popin de création
        this.matDialog.open(ApiClefAddComponent,{
            width: '60%'
        }).afterClosed().subscribe(refresh => {
            if (refresh) {
                //Rafraichissement de la liste
                this.listeClefApi.refresh();
            }
        });
    }
}
